import { FieldMessageType } from '@components/form/field';
import cx from 'classnames';

export const getFieldMessageStylesAsClassName = (
  type: FieldMessageType
): string => {
  return cx('flex items-center pt-1 pr-4', {
    'text-gray-main': type === FieldMessageType.HINT,
    'text-secondary-main': type === FieldMessageType.INFO,
    'text-error-main': type === FieldMessageType.ERROR,
    'text-success-main': type === FieldMessageType.SUCCESS,
  });
};
